<template>
    <Card>
        <SearchLine @search="onSearch"></SearchLine>
        <div class="total-line">
            <template v-for="(item, index) in dataList" :key="index">
                <TotalBlock v-bind="item"></TotalBlock>
                <div class="split-line" v-if="index < dataList.length - 1"></div>
            </template>
        </div>
    </Card>
</template>
<script>
import TotalBlock from "./TotalBlock.vue";
import SearchLine from "./SearchLine.vue";
export default {
    name: "TotalNumber",
    components: { TotalBlock, SearchLine },
    data() {
        return {
            dataList: [],
        };
    },
    created() {},
    methods: {
        onSearch(data) {
            this.$emit("search", data);
        },

        setData(data) {
            this.$ajax.post("/AnalyzeData/GetEntityTotalNumber", data).then((result) => {
                let arr = result.Data;
                let list = [
                    {
                        title: "进场人流(人)",
                        data: {
                            d: arr[0].DataIn,
                            d1: arr[1].DataIn,
                            d2: arr[2].DataIn,
                            d3: arr[3].DataIn,
                        },
                        dec: 0,
                    },
                    {
                        title: "出场人流(人)",
                        data: {
                            d: arr[0].FlowDensity,
                            d1: arr[1].FlowDensity,
                            d2: arr[2].FlowDensity,
                            d3: arr[3].FlowDensity,
                        },
                        dec: 0,
                    },
                    {
                        title: "在场人数(人)",
                        data: {
                            d: arr[0].Amount,
                            d1: arr[1].Amount,
                            d2: arr[2].Amount,
                            d3: arr[3].Amount,
                        },
                        dec: 0,
                    },
                    {
                        title: "人流密度(人/m2)",
                        data: {
                            d: arr[0].OrderRate,
                            d1: arr[1].OrderRate,
                            d2: arr[2].OrderRate,
                            d3: arr[3].OrderRate,
                        },
                        dec: 2,
                    },
                    {
                        title: "停留时间(h/人)",
                        data: {
                            d: arr[0].Price,
                            d1: arr[1].Price,
                            d2: arr[2].Price,
                            d3: arr[3].Price,
                        },
                        dec: 2,
                    },
                ];
                this.dataList = list;
            });
        },
    },
};
</script>
